import { useMemo } from 'react';

import { useStaticContext } from '~/utilities/context/static/StaticContext';
import type { PriceDisplayConfiguration } from '~/utilities/graphql/codegen';
import { PriceDisplayMode } from '~/utilities/graphql/codegen';

type ReturnType = PriceDisplayConfiguration | undefined;

/**
 * Resolves the price display configuration for the current product
 * from the site configuration, keyed by the product's `priceDisplayMode`.
 */
export const usePriceDisplayConfiguration = (
  priceDisplayMode: PriceDisplayMode | null = PriceDisplayMode.Default
): ReturnType => {
  const {
    configuration: { priceDisplayConfigurations },
  } = useStaticContext();

  return useMemo(
    () => priceDisplayConfigurations?.find(({ displayMode }) => displayMode === priceDisplayMode),
    [priceDisplayMode, priceDisplayConfigurations]
  );
};
